import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Switch } from "@/components/ui/switch";
import { Mail } from "lucide-react";
import { toast } from "sonner";

export function EmailNotificationToggle() {
  const { user, setUser } = useAuth();
  const [saving, setSaving] = useState(false);
  const enabled = user?.email_notifications !== false;

  const toggle = async (v) => {
    setSaving(true);
    try {
      await api.patch("/me/preferences", { email_notifications: v });
      setUser((u) => ({ ...u, email_notifications: v }));
      toast.success(v ? "Email notifications on" : "Email notifications off");
    } catch {
      toast.error("Could not update preference");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mx-auto mt-6 max-w-2xl px-4 sm:px-6 lg:px-8">
      <div className="flex items-center justify-between gap-3 rounded-2xl border border-zinc-200 bg-white p-4">
        <div className="flex items-start gap-3">
          <span className="mt-0.5 flex h-9 w-9 items-center justify-center rounded-xl bg-emerald-100 text-emerald-600"><Mail className="h-4 w-4" /></span>
          <div>
            <p className="font-display font-semibold text-zinc-900">Email notifications</p>
            <p className="text-sm text-zinc-500">Get an email when you receive a new message. We never include the message text — just a link to log in and read it.</p>
          </div>
        </div>
        <Switch data-testid="email-notifications-toggle" checked={enabled} disabled={saving} onCheckedChange={toggle} />
      </div>
    </div>
  );
}
